import { render, staticRenderFns } from "./MultiCheckbox.vue?vue&type=template&id=f5bc3f3a&scoped=true&"
import script from "./MultiCheckbox.vue?vue&type=script&lang=js&"
export * from "./MultiCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MultiCheckbox.vue?vue&type=style&index=0&id=f5bc3f3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bc3f3a",
  null
  
)

export default component.exports